import React, { useEffect } from "react";
import DroneSevicesHero from "../components/droneSevicesPage/DroneSevicesHero";
import Navbar from "../components/homepage/Navbar";
 
import DroneRepaire from "../components/droneSevicesPage/DroneRepaire";
import SevicesNeedMoreInfo from "../components/droneSevicesPage/SevicesNeedMoreInfo";
import HowItWorks from "../components/droneSevicesPage/HowItWorks";
import { Header, Footer } from "../shared";

const DroneSevicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="BuyCertifiedDrone_backgorund">
      <div className="bg_darkblue">
        <Header />
      </div>
      {/* <DroneSevicesHero /> */}
      <DroneRepaire />
      {/* <HowItWorks /> */}
      {/* <SevicesNeedMoreInfo /> */}
      <Footer />
    </div>
  );
};

export default DroneSevicesPage;
